/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-10 20:01:31
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {StationListDOI} from "./api/stationListApi";
import StationListService from "./service/stationListService";
import './stationList.less';

@Component({name: 'station-list'})
export default class StationList extends BasicSearchPage<StationListService, StationListDOI.RowDataI, StationListDOI.QueryRowDataParamsI> {


    renderHead(h){return <div></div>}

    @override
    mounted () {
        //5
        this.$route.query.deviceStatus && (this.queryFormData.find((i:any)=> i.field === 'site_status')!.props.value = +this.$route.query.deviceStatus)
		this.service.initSearchParams()
        this.searchTable()
    }
    
	@override
	loadService () {
        //1
		this.service = new StationListService(this)
	}
}